import API from '../app.api';

export const getSupplies = async () => {
    const res = await API.get('/api/v1/supplies-order');
    return res.data;
};

export const orderSupplies = async (suppliesOrder) => {
    const res = await API.post('/api/v1/supplies-order', suppliesOrder);
    return res.data;
};
